import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import TypeOfField from "../../../../FormikFields/TypeOfField";
import AutoFill from "../../../../FormikFields/AutoFill";
import { useTranslation } from "react-i18next";
import config from "../../../../../config"

function Options({ formik, optionList }) {
  const { t } = useTranslation();
  const { theme: { bgColors } } = useTheme();
  const [autoFillStatus, setAutoFillStatus] = useState(null);
  const [autoFillStatusForMouse, setAutoFillStatusForMouse] = useState(null);

  const handleCompany = () => {
    setAutoFillStatus('company')
    formik.setFieldValue("showSpelling", true)
    formik.setFieldValue("showArchive", true)
    formik.setFieldValue("saveTextAfterSession", true)
    formik.setFieldValue("emailNotificationOnWord", 1)
    formik.setFieldValue("defaultBenchmark", 1)
    formik.setFieldValue("defaultLanguage", 1)
  }

  const handleGroup = () => {
    setAutoFillStatus('group')
    formik.setFieldValue("showSpelling", false)
    formik.setFieldValue("showArchive", false)
    formik.setFieldValue("saveTextAfterSession", false)
    formik.setFieldValue("emailNotificationOnWord", 2)
    formik.setFieldValue("defaultBenchmark", 2)
    formik.setFieldValue("defaultLanguage", 2)
  }

  const Input = (f, value) => {
    const label = `admin_user_option_${f.name}`
    if (f.type === "boolean") {
      return <TypeOfField disabled={value} control="switch" formik={formik} name={f.name} style={{ maxWidth: "300px", width: "400px" }}
        {...f} />
    } else if (f.type === "datetime") {
      return <TypeOfField disabled={value} control="date" formik={formik} name={f.name} label={t(label)} {...f} />
    } else {
      return <TypeOfField disabled={value} control="text" formik={formik} name={f.name} style={{ maxWidth: "300px", width: "400px" }}
        label="value" {...f} />
    }
  }

  return (
    <div style={{ backgroundColor: bgColors.bgPrimary0 }} className={`position-relative`}>
      <AutoFill title={t("Options")} state={autoFillStatus} setAutoFillState={setAutoFillStatus} stateForMouse={autoFillStatusForMouse}
        setStateForMouse={setAutoFillStatusForMouse} handleCompany={handleCompany} handleGroup={handleGroup} />
      <div>
        <br />
        <ul className={`mb-0`}>
          {
            optionList?.length && optionList.filter(opt => config.enabledUserOptions.includes(opt.name))
            .map((f, i) => (
              <li key={i}>
                  <div style={{ display: "flex", width:"100%"}}>
                  {(formik.values.company === '') ?
                    Input(f, true) :
                    Input(f, false)
                  }
                </div>
              </li>
            )
            )
          }
        </ul>
      </div>
    </div>
  )
}

export default Options
